import httpClient from '@/api/http-client';

import { type BankAccount  } from '@/models/bank-account.model';
import { type PlaidLinkToken } from '@/models/plaid-link-token.model';

export enum BankAccountsApiExceptionCodes {
  BAD_REQUEST = 4003,
  INVALID_ROUTING_NUMBER = 4007,
}

type BankAccountPlaidLinkData = {
  plaidAccountId: string;
  plaidLinkSessionId: string;
  plaidPublicToken: string;
  plaidVerificationStatus: null | string;  
}

export type CreateBankAccountRequest = {
  bankAccountName?: string;
  bankName?: string;
} & BankAccountPlaidLinkData;

export type UpdateBankAccountOwnerRequest = {
  bankAccountOwnerName: string;
}

export type UpdateBankAccountPlaidLinkDataRequest = BankAccountPlaidLinkData;

export type WireRoutingNumberDetails = {
  customerName: string;
  routingNumber: string;
}

export type CreatePlaidLinkToken = {
  bankAccountId: null | string;
}

async function createPlaidLinkToken (payload: CreatePlaidLinkToken = {
  bankAccountId: null,
}) {
  const { data } = await httpClient.post<PlaidLinkToken>('bank-accounts/plaid-link-token', payload);
  return data;
}

async function create (payload: CreateBankAccountRequest) {
  const { data } = await httpClient.post<BankAccount>('bank-accounts', payload);
  return data;
}

async function updateOwner (bankAccountId: string, payload: UpdateBankAccountOwnerRequest) {
  const { data } = await httpClient.put<BankAccount>(`bank-accounts/${bankAccountId}/account-owner`, payload);
  return data;
}

async function updatePlaidLinkData (bankAccountId: string, payload: UpdateBankAccountPlaidLinkDataRequest) {
  const { data } = await httpClient.put<BankAccount>(`bank-accounts/${bankAccountId}/plaid-link-data`, payload);
  return data;
}

async function validateWireRoutingNumber (routingNumber: string) {
  const { data } = await httpClient.get<null | WireRoutingNumberDetails>('bank-accounts/validate-routing-number', {
    params: {
      routingNumber,
    },
  });
  return data;
}

async function addWireRoutingNumber (bankAccountId: string, wireRoutingNumber: string) {
  const { data } = await httpClient.post<BankAccount>(`bank-accounts/${bankAccountId}/wire-routing-number`, {
    wireRoutingNumber,
  });
  return data;
}

async function list () {
  const { data } = await httpClient.get<BankAccount[]>('bank-accounts');
  return data;
}

export default {
  addWireRoutingNumber,
  create,
  createPlaidLinkToken,
  list,
  updateOwner,
  updatePlaidLinkData,
  validateWireRoutingNumber,
};
